// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__Qg2nP","hero_details":"Hero_hero_details__TZj8u","search":"Hero_search__zFqto","images":"Hero_images__Vix+A","top":"Hero_top__FCUSz"};